"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
        onCreate: function() {
          GState.bind(this, [
              "tenant",
              "theme"
            ]);
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/TenantLogo/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value");

function render(input, out, __component, component, state) {
  var data = input;

  if (state.tenant && state.tenant.logo) {
    out.e("img", {
        src: state.tenant.logo,
        "class": marko_classValue(marko_classValue([
          "rounded",
          input.class
        ])),
        style: marko_styleValue(state.style || "width:60px")
      }, "0", component, 0);
  } else {
    out.e("img", {
        src: ("/images/favicon/logo-round" + (state.theme.mode == "dark" ? "-white" : "")) + ".png",
        "class": marko_classValue(marko_classValue([
          "rounded",
          input.class
        ])),
        style: marko_styleValue(state.style || "width:60px")
      }, "1", component, 0);
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
